import React, { FunctionComponent, PropsWithChildren } from 'react';

import {
  default as MuiDialogContentText,
  DialogContentTextProps,
} from '@mui/material/DialogContentText';

const DialogContentText: FunctionComponent<DialogContentTextProps> = (
  props: PropsWithChildren<DialogContentTextProps>
) => {
  return (
    <MuiDialogContentText {...props}>{props.children}</MuiDialogContentText>
  );
};

export default DialogContentText;
